import React, { Component } from 'react';

class Denominacion extends Component {
    constructor(props){
        super(props)
        this.state={
            apellidoAdicional:"",
            nombreAdicional:"",
            nombreCargado:false
        }
    }
onInputChange(e){
    const { value, dataset } = e.target;
    const regExp = new RegExp(/^[a-záéíóúñÑA-Z\.]*$/);

    if(regExp.test(value)){
        if(dataset.code=="Apellido"){
            this.props.changeInput("apellidoAdicional", value)
            this.setState({
                apellidoAdicional:value,
            })        
        }
        if(dataset.code=="Nombre"){
            this.props.changeInput("nombreAdicional", value)
            this.setState({
                nombreAdicional:value,
            })        
        }
    }   
}
componentDidMount(){
    this.setState({
        apellidoAdicional:this.props.data.apellidoAdicional,
        nombreAdicional:this.props.data.nombreAdicional,
    })
}
componentWillReceiveProps(nextprops){
    if((nextprops.data.idAdicional!==this.props.data.idAdicional)||
     nextprops.data.cuentasAdicionales.length !==this.props.data.cuentasAdicionales ){
        this.setState({
            apellidoAdicional:nextprops.data.apellidoAdicional,
            nombreAdicional:nextprops.data.nombreAdicional,
        })          
    }
    if(!this.state.nombreCargado){
        
        const {tarjetas} = this.props;
        let nombre, apellido;
        
        if(tarjetas && tarjetas.clienteTarjeta && tarjetas.clienteTarjeta.APELLIDO && this.props.data.idAdicional == 0){
            apellido = tarjetas.clienteTarjeta.APELLIDO.substring(0,17);
            let largoApellido = apellido.length;
            nombre = tarjetas.clienteTarjeta.NOMBRE.substring(0,18-largoApellido);

            this.props.changeInput("apellidoAdicional", apellido);
            this.props.changeInput("nombreAdicional", nombre);
            this.setState({apellidoAdicional:apellido,nombreAdicional:nombre,nombreCargado:true });

        }

    }
}

    render() {
        const {data}=this.props
        return (
            <div className="row top-separator-xs">
                <div className="col-md-12">
                    <label className="label-primary">Denominación</label>
                    <div className="row">
                        <div className="col-md-3">
                            <input
                                placeholder="Nombre"
                                className="textbox-rectangular form-control default-input"
                                type="text"
                                value={this.state.nombreAdicional}
                                onChange={this.onInputChange.bind(this)}
                                data-code="Nombre"
                                maxLength="17"
                            />
                        </div>

                        <div className="col-md-3">
                            <input
                                placeholder="Apellido"
                                className="textbox-rectangular form-control default-input"
                                type="text"
                                value={this.state.apellidoAdicional}
                                onChange={this.onInputChange.bind(this)}
                                data-code="Apellido"
                                maxLength="17"
                            />
                        </div>

                        <div className="col-md-4"></div>

                    </div>
                    {(!data.ERROR_ADICIONAL["seleccionoDenominacionAdicional"]&& (this.state.nombreAdicional.length + this.state.apellidoAdicional.length>18))
                        && <label className="error">{"El Nombre y Apellido para la denominacion no pueden superar los 18 caracteres"}</label>
                    }
                    {(!data.ERROR_ADICIONAL["seleccionoDenominacionAdicional"]&& ((this.state.nombreAdicional!="" && this.state.apellidoAdicional!="") && (this.state.nombreAdicional[0] == "." || this.state.apellidoAdicional[0] == ".")))
                        && <label className="error">{"El primer caracter no puede ser un punto."}</label>
                    }
    
                    {(!data.ERROR_ADICIONAL["seleccionoDenominacionAdicional"]&& (this.state.nombreAdicional==""|| this.state.apellidoAdicional==""))
                        && <label className="error">{"Debe ingresar un Nombre y Apellido"}</label>}
            
                </div>
            </div>
        );
    }
};

export default Denominacion;